module.exports = __webpack_public_path__ + "static/img/bg.4cfe637.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd103/bg.png
// module id = ORCd
// module chunks = 1